import { inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { PreviewService } from '../services/preview.service';

@Injectable()
export class PreviewInterceptor implements HttpInterceptor {
  private previewService: PreviewService = inject(PreviewService);

  intercept(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    req: HttpRequest<any>,
    next: HttpHandler
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<HttpEvent<any>> {
    if (this.previewService.previewToken) {
      try {
        const path = new URL(req.url).pathname.split('/');

        if (path.length > 1 && path[1] === 'api') {
          const params = req.params.set(
            'preview_token',
            this.previewService.previewToken
          );
          return next.handle(req.clone({ params }));
        }
      } catch (error) {
        return next.handle(req);
      }
    }
    return next.handle(req);
  }
}
